const PUBLIC_PAGE_BASE_PATHS = [
  '/master-data/customer/public-show',
  '/supplier-quote',
  '/quotation-public',
  '/order-progress',
  '/q',
] as const;

const STANDALONE_PAGE_BASE_PATHS = [
  '/process/designer',
  '/system/print-template/design',
  '/pbo-designer',
  '/user',
] as const;

const matchesBasePath = (pathname: string, basePath: string): boolean =>
  pathname === basePath || pathname.startsWith(`${basePath}/`);

export const isPublicPagePath = (pathname: string): boolean =>
  PUBLIC_PAGE_BASE_PATHS.some((basePath) =>
    matchesBasePath(pathname, basePath),
  );

export const isPdaPagePath = (pathname: string): boolean =>
  matchesBasePath(pathname, '/pda');

/**
 * PDA uses its own login flow. External public pages use token-scoped APIs.
 * Neither should be redirected through the authenticated PC application.
 */
export const isAuthenticationExemptPath = (pathname: string): boolean =>
  isPublicPagePath(pathname) || isPdaPagePath(pathname);

export const isStandalonePagePath = (pathname: string): boolean =>
  isPublicPagePath(pathname) ||
  isPdaPagePath(pathname) ||
  STANDALONE_PAGE_BASE_PATHS.some((basePath) =>
    matchesBasePath(pathname, basePath),
  ) ||
  pathname.includes('/print-business-object/designer');
